export default function IosBasketball() {
  return (
    <div
      className="ion-icon-ios-basketball"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<path d="M256,48C141.137,48,48,141.136,48,256s93.137,208,208,208c114.871,0,208-93.138,208-208S370.871,48,256,48z
	 M380.797,400.032c-4.158,3.608-8.48,7.029-12.942,10.272c-21.704-50.015-50.938-95.795-87.168-136.465
	c-15.118,15.728-31.203,30.518-48.156,44.28c27.659,35.364,44.916,79.254,47.189,127.069c-5.252,0.655-10.571,1.086-15.944,1.303
	c-1.103-24.727-6.5-48.721-16.114-71.45c-7.158-16.922-16.431-32.665-27.68-47.037c-31.104,23.733-64.923,44.093-100.91,60.526
	c-3.883-4.011-7.592-8.191-11.115-12.529c36.28-16.134,70.291-36.271,101.705-60.186c-2.139-2.34-4.33-4.641-6.584-6.895
	c-19.107-19.107-41.354-34.107-66.12-44.583c-22.015-9.312-46.212-14.964-71.45-16.108c0.217-5.379,0.648-10.703,1.303-15.959
	c61.62,2.929,116.713,30.753,155.45,73.638c13.802-11.208,27.075-23.167,39.778-35.87c2.638-2.638,5.238-5.303,7.812-7.988
	c-3.223-3.4-6.489-6.767-9.812-10.09c-45.887-45.886-99.137-82.145-158.332-107.832c3.243-4.461,6.665-8.782,10.272-12.939
	c63.951,28.387,121.212,69.101,168.767,119.132c10.711-11.889,20.824-24.216,30.319-36.965
	c-40.347-37.271-66.956-89.188-71.388-147.312c5.273-0.449,10.604-0.692,15.99-0.702c1.738,22.238,6.974,43.838,15.671,64.401
	c10.476,24.767,25.476,47.013,44.583,66.12c1.5,1.5,3.025,2.965,4.562,4.413c20.226-29.031,37.379-60.104,51.287-92.987
	c0.285-0.674,0.555-1.353,0.835-2.028c4.419,3.426,8.681,7.042,12.779,10.835c-14.383,33.502-32.132,65.215-52.822,94.716
	c15.026,12.13,31.591,22.068,49.479,29.635c20.631,8.727,42.305,13.978,64.62,15.698c-0.004,5.387-0.243,10.717-0.688,15.991
	c-46.278-3.479-88.631-21.018-122.801-48.359c-9.922,13.275-20.455,26.067-31.556,38.336
	C328.091,302.883,358.307,349.36,380.797,400.032z"/>
</svg>
`,
      }}
    />
  )
}
